var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightmapLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 186.3 49",
    style: {
      enableBackground: "new 0 0 186.3 49"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.9,30.2v3H58.4v-17h3.5v14H69.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.8,33.2v-17h3.5v17H71.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91,17.4c1.2,1,1.9,2.4,2.1,4.2h-3.8c-0.2-0.8-0.5-1.5-1.1-1.9c-0.6-0.4-1.3-0.7-2.2-0.7 c-1.4,0-2.4,0.5-3.2,1.6c-0.8,1-1.2,2.5-1.2,4.3c0,1.9,0.4,3.3,1.2,4.4c0.8,1.1,1.8,1.6,3.2,1.6c1.2,0,2.2-0.3,2.8-1 c0.7-0.7,1-1.7,1-3h-4v-2.9h7.3v9.3h-3v-1.8h0c-0.5,0.7-1.2,1.2-2,1.6s-1.8,0.6-2.9,0.6c-1.4,0-2.7-0.4-3.8-1.1 c-1.1-0.7-1.9-1.7-2.5-3c-0.6-1.3-0.9-2.9-0.9-4.7c0-1.8,0.3-3.4,1-4.8c0.7-1.3,1.6-2.4,2.8-3.1c1.2-0.7,2.6-1.1,4.3-1.1 C88.1,15.8,89.8,16.3,91,17.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.9,33.2v-7.3h-7v7.3h-3.5v-17h3.5v6.6h7v-6.6h3.5v17H106.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.2,19.2v14h-3.5v-14h-5.3v-3h14.2v3H121.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.7,33.2v-8.4c0-2.1,0-4.2,0.1-6.4h0c-0.5,2-1.1,4.1-1.8,6.2l-2.7,8.6h-4l-2.7-8.6 c-0.7-2.2-1.3-4.2-1.8-6.2h0c0.1,2.1,0.1,4.2,0.1,6.4v8.4h-3.4v-17h5.6l2.5,7.8c0.7,2.1,1.2,4.2,1.7,6.2h0c0.4-2,1-4.1,1.7-6.2 l2.5-7.8h5.6v17H144.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M154.9,29l-1.3,4.1h-3.7l5.9-17h4.7l5.9,17h-3.7l-1.3-4.1H154.9z M160.1,24.9c-0.8-2.5-1.4-4.7-1.9-6.6h0 c-0.6,2.2-1.2,4.4-1.9,6.6l-0.4,1.1h4.6L160.1,24.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.3,17.7c1.1,1,1.6,2.3,1.6,4c0,1.7-0.5,3-1.6,4c-1.1,1-2.6,1.5-4.6,1.5h-2.9v6h-3.5v-17h6.4 C176.7,16.2,178.3,16.7,179.3,17.7z M171.8,24.3h2.4c2.1,0,3.1-0.9,3.1-2.6c0-1.7-1-2.6-3.1-2.6h-2.4V24.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3.8,
    y: 5.8,
    className: "st0",
    width: 17.5,
    height: 17.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.8,
    y: 26.1,
    className: "st0",
    width: 17.5,
    height: 17.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.1,
    y: 26.1,
    className: "st0",
    width: 17.5,
    height: 17.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.8,23.3L32.8,23.3c-4.8,0-8.7-3.9-8.7-8.7v0c0-4.8,3.9-8.7,8.7-8.7h0c4.8,0,8.7,3.9,8.7,8.7v0 C41.5,19.4,37.6,23.3,32.8,23.3z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightmapLogo);
export default __webpack_public_path__ + "static/media/Lightmap_logo.a9dbd3e60732b0d3175e7d68a132cfac.svg";
export { ForwardRef as ReactComponent };